import { render, staticRenderFns } from "./ErrorSnackbar.vue?vue&type=template&id=6d7c0433"
import script from "./ErrorSnackbar.vue?vue&type=script&lang=ts"
export * from "./ErrorSnackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d7c0433')) {
      api.createRecord('6d7c0433', component.options)
    } else {
      api.reload('6d7c0433', component.options)
    }
    module.hot.accept("./ErrorSnackbar.vue?vue&type=template&id=6d7c0433", function () {
      api.rerender('6d7c0433', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Snackbar/ErrorSnackbar.vue"
export default component.exports